export const convertUrlToBase64 = async (url: string) => {
  const blob = await convertUrlToBlob(url);
  return await convertBlobToBase64(blob);
};

export const convertUrlToBlob = async (url: string) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(
      `Il y a une erreur avec l'URL suivante ; ${url} - status: ${response.status} - message: ${response.statusText}`
    );
  }
  return response.blob();
};

export const fileToBase64 = async (file: File) => {
  const arrayBuffer = await file.arrayBuffer();
  return btoa(new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ""));
};

export const convertBlobToBase64 = async (blob: Blob) => {
  const arrayBuffer = await blob.arrayBuffer();
  return btoa(new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ""));
};

export const convertBase64ToBlob = (base64: string, type = "application/octet-stream") => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  return new Blob([byteNumbers], { type });
};

export const getBase64SizeInMB = (base64: string) => {
  const base64WithoutPrefix = base64.replace(/^data:[a-zA-Z0-9]+\/[a-zA-Z0-9]+;base64,/, "");
  const sizeInBytes = (base64WithoutPrefix.length * 3) / 4; // Base64 to bytes conversion
  // Convert to megabytes
  return (sizeInBytes / (1024 * 1024)).toFixed(2);
};

/**
 * Extracts the base64 portion from a `data:*;base64,...` Data URL.
 *
 * If the input doesn't match a Data URL format, we return the input as-is.
 */
export const extractBase64FromDataUrl = (value: string): string => {
  const match = value.match(/^data:[^,]*;base64,(.*)$/);
  if (match?.[1]) return match[1];

  // Backward-safe fallback: mimic previous behavior that returned the last
  // comma-separated segment (for inputs that already look like Data URLs).
  const parts = value.split(",");
  return parts.length >= 2 ? (parts.at(-1) ?? value) : value;
};

export const getBlobSizeInMB = (blob: Blob) => {
  return (blob.size / (1024 * 1024)).toFixed(2);
};
